// Render-order constants for scene objects whose draw order is fixed (not
// configurable via params). Higher values draw later — i.e. on top — when
// the depth test is disabled or transparency is in play.
//
// Default (param-driven primitives — slices, contour, fieldlines): 0.
// Volume sits above the default so its raymarched output composites over
// any opaque scene geometry behind it. Selection wireframes sit above the
// volume so they remain visible against bright volume regions.

export const RENDER_ORDER = {
    VOLUME: 5,
    SELECTION_WIREFRAME: 6,
} as const;
